import t from '../../translation';

const armor = {
  201402: {
    text: t('armorMystery201402Text'),
    notes: t('armorMystery201402Notes'),
    mystery: '201402',
    value: 0,
  },
  201403: {
    text: t('armorMystery201403Text'),
    notes: t('armorMystery201403Notes'),
    mystery: '201403',
    value: 0,
  },
  201405: {
    text: t('armorMystery201405Text'),
    notes: t('armorMystery201405Notes'),
    mystery: '201405',
    value: 0,
  },
  201406: {
    text: t('armorMystery201406Text'),
    notes: t('armorMystery201406Notes'),
    mystery: '201406',
    value: 0,
  },
  201407: {
    text: t('armorMystery201407Text'),
    notes: t('armorMystery201407Notes'),
    mystery: '201407',
    value: 0,
  },
  201408: {
    text: t('armorMystery201408Text'),
    notes: t('armorMystery201408Notes'),
    mystery: '201408',
    value: 0,
  },
  201409: {
    text: t('armorMystery201409Text'),
    notes: t('armorMystery201409Notes'),
    mystery: '201409',
    value: 0,
  },
  201410: {
    text: t('armorMystery201410Text'),
    notes: t('armorMystery201410Notes'),
    mystery: '201410',
    value: 0,
  },
  201412: {
    text: t('armorMystery201412Text'),
    notes: t('armorMystery201412Notes'),
    mystery: '201412',
    value: 0,
  },
  201501: {
    text: t('armorMystery201501Text'),
    notes: t('armorMystery201501Notes'),
    mystery: '201501',
    value: 0,
  },
  201503: {
    text: t('armorMystery201503Text'),
    notes: t('armorMystery201503Notes'),
    mystery: '201503',
    value: 0,
  },
  201504: {
    text: t('armorMystery201504Text'),
    notes: t('armorMystery201504Notes'),
    mystery: '201504',
    value: 0,
  },
  201506: {
    text: t('armorMystery201506Text'),
    notes: t('armorMystery201506Notes'),
    mystery: '201506',
    value: 0,
  },
  201508: {
    text: t('armorMystery201508Text'),
    notes: t('armorMystery201508Notes'),
    mystery: '201508',
    value: 0,
  },
  201509: {
    text: t('armorMystery201509Text'),
    notes: t('armorMystery201509Notes'),
    mystery: '201509',
    value: 0,
  },
  201511: {
    text: t('armorMystery201511Text'),
    notes: t('armorMystery201511Notes'),
    mystery: '201511',
    value: 0,
  },
  201512: {
    text: t('armorMystery201512Text'),
    notes: t('armorMystery201512Notes'),
    mystery: '201512',
    value: 0,
  },
  201603: {
    text: t('armorMystery201603Text'),
    notes: t('armorMystery201603Notes'),
    mystery: '201603',
    value: 0,
  },
  201604: {
    text: t('armorMystery201604Text'),
    notes: t('armorMystery201604Notes'),
    mystery: '201604',
    value: 0,
  },
  201605: {
    text: t('armorMystery201605Text'),
    notes: t('armorMystery201605Notes'),
    mystery: '201605',
    value: 0,
  },
  201606: {
    text: t('armorMystery201606Text'),
    notes: t('armorMystery201606Notes'),
    mystery: '201606',
    value: 0,
  },
  201607: {
    text: t('armorMystery201607Text'),
    notes: t('armorMystery201607Notes'),
    mystery: '201607',
    value: 0,
  },
  201609: {
    text: t('armorMystery201609Text'),
    notes: t('armorMystery201609Notes'),
    mystery: '201609',
    value: 0,
  },
  201610: {
    text: t('armorMystery201610Text'),
    notes: t('armorMystery201610Notes'),
    mystery: '201610',
    value: 0,
  },
  201612: {
    text: t('armorMystery201612Text'),
    notes: t('armorMystery201612Notes'),
    mystery: '201612',
    value: 0,
  },
  201703: {
    text: t('armorMystery201703Text'),
    notes: t('armorMystery201703Notes'),
    mystery: '201703',
    value: 0,
  },
  201704: {
    text: t('armorMystery201704Text'),
    notes: t('armorMystery201704Notes'),
    mystery: '201704',
    value: 0,
  },
  201707: {
    text: t('armorMystery201707Text'),
    notes: t('armorMystery201707Notes'),
    mystery: '201707',
    value: 0,
  },
  201710: {
    text: t('armorMystery201710Text'),
    notes: t('armorMystery201710Notes'),
    mystery: '201710',
    value: 0,
  },
  201711: {
    text: t('armorMystery201711Text'),
    notes: t('armorMystery201711Notes'),
    mystery: '201711',
    value: 0,
  },
  201712: {
    text: t('armorMystery201712Text'),
    notes: t('armorMystery201712Notes'),
    mystery: '201712',
    value: 0,
  },
  201802: {
    text: t('armorMystery201802Text'),
    notes: t('armorMystery201802Notes'),
    mystery: '201802',
    value: 0,
  },
  201806: {
    text: t('armorMystery201806Text'),
    notes: t('armorMystery201806Notes'),
    mystery: '201806',
    value: 0,
  },
  201807: {
    text: t('armorMystery201807Text'),
    notes: t('armorMystery201807Notes'),
    mystery: '201807',
    value: 0,
  },
  201808: {
    text: t('armorMystery201808Text'),
    notes: t('armorMystery201808Notes'),
    mystery: '201808',
    value: 0,
  },
  201809: {
    text: t('armorMystery201809Text'),
    notes: t('armorMystery201809Notes'),
    mystery: '201809',
    value: 0,
  },
  201810: {
    text: t('armorMystery201810Text'),
    notes: t('armorMystery201810Notes'),
    mystery: '201810',
    value: 0,
  },
  201903: {
    text: t('armorMystery201903Text'),
    notes: t('armorMystery201903Notes'),
    mystery: '201903',
    value: 0,
  },
  201904: {
    text: t('armorMystery201904Text'),
    notes: t('armorMystery201904Notes'),
    mystery: '201904',
    value: 0,
  },
  201906: {
    text: t('armorMystery201906Text'),
    notes: t('armorMystery201906Notes'),
    mystery: '201906',
    value: 0,
  },
  201907: {
    text: t('armorMystery201907Text'),
    notes: t('armorMystery201907Notes'),
    mystery: '201907',
    value: 0,
  },
  201908: {
    text: t('armorMystery201908Text'),
    notes: t('armorMystery201908Notes'),
    mystery: '201908',
    value: 0,
  },
  201909: {
    text: t('armorMystery201909Text'),
    notes: t('armorMystery201909Notes'),
    mystery: '201909',
    value: 0,
  },
  201910: {
    text: t('armorMystery201910Text'),
    notes: t('armorMystery201910Notes'),
    mystery: '201910',
    value: 0,
  },
  301404: {
    text: t('armorMystery301404Text'),
    notes: t('armorMystery301404Notes'),
    mystery: '301404',
    value: 0,
  },
  301703: {
    text: t('armorMystery301703Text'),
    notes: t('armorMystery301703Notes'),
    mystery: '301703',
    value: 0,
  },
  301704: {
    text: t('armorMystery301704Text'),
    notes: t('armorMystery301704Notes'),
    mystery: '301704',
    value: 0,
  },
};

const back = {
  201402: {
    text: t('backMystery201402Text'),
    notes: t('backMystery201402Notes'),
    mystery: '201402',
    value: 0,
  },
  201404: {
    text: t('backMystery201404Text'),
    notes: t('backMystery201404Notes'),
    mystery: '201404',
    value: 0,
  },
  201410: {
    text: t('backMystery201410Text'),
    notes: t('backMystery201410Notes'),
    mystery: '201410',
    value: 0,
  },
  201504: {
    text: t('backMystery201504Text'),
    notes: t('backMystery201504Notes'),
    mystery: '201504',
    value: 0,
  },
  201507: {
    text: t('backMystery201507Text'),
    notes: t('backMystery201507Notes'),
    mystery: '201507',
    value: 0,
  },
  201510: {
    text: t('backMystery201510Text'),
    notes: t('backMystery201510Notes'),
    mystery: '201510',
    value: 0,
  },
  201602: {
    text: t('backMystery201602Text'),
    notes: t('backMystery201602Notes'),
    mystery: '201602',
    value: 0,
  },
  201608: {
    text: t('backMystery201608Text'),
    notes: t('backMystery201608Notes'),
    mystery: '201608',
    value: 0,
  },
  201702: {
    text: t('backMystery201702Text'),
    notes: t('backMystery201702Notes'),
    mystery: '201702',
    value: 0,
  },
  201704: {
    text: t('backMystery201704Text'),
    notes: t('backMystery201704Notes'),
    mystery: '201704',
    value: 0,
  },
  201706: {
    text: t('backMystery201706Text'),
    notes: t('backMystery201706Notes'),
    mystery: '201706',
    value: 0,
  },
  201709: {
    text: t('backMystery201709Text'),
    notes: t('backMystery201709Notes'),
    mystery: '201709',
    value: 0,
  },
  201801: {
    text: t('backMystery201801Text'),
    notes: t('backMystery201801Notes'),
    mystery: '201801',
    value: 0,
  },
  201803: {
    text: t('backMystery201803Text'),
    notes: t('backMystery201803Notes'),
    mystery: '201803',
    value: 0,
  },
  201804: {
    text: t('backMystery201804Text'),
    notes: t('backMystery201804Notes'),
    mystery: '201804',
    value: 0,
  },
  201805: {
    text: t('backMystery201805Text'),
    notes: t('backMystery201805Notes'),
    mystery: '201805',
    value: 0,
  },
  201812: {
    text: t('backMystery201812Text'),
    notes: t('backMystery201812Notes'),
    mystery: '201812',
    value: 0,
  },
  201905: {
    text: t('backMystery201905Text'),
    notes: t('backMystery201905Notes'),
    mystery: '201905',
    value: 0,
  },
  201912: {
    text: t('backMystery201912Text'),
    notes: t('backMystery201912Notes'),
    mystery: '201912',
    value: 0,
  },
  202001: {
    text: t('backMystery202001Text'),
    notes: t('backMystery202001Notes'),
    mystery: '202001',
    value: 0,
  },
};

const body = {
  201705: {
    text: t('bodyMystery201705Text'),
    notes: t('bodyMystery201705Notes'),
    mystery: '201705',
    value: 0,
  },
  201706: {
    text: t('bodyMystery201706Text'),
    notes: t('bodyMystery201706Notes'),
    mystery: '201706',
    value: 0,
  },
  201711: {
    text: t('bodyMystery201711Text'),
    notes: t('bodyMystery201711Notes'),
    mystery: '201711',
    value: 0,
  },
  201901: {
    text: t('bodyMystery201901Text'),
    notes: t('bodyMystery201901Notes'),
    mystery: '201901',
    value: 0,
  },
  202002: {
    text: t('bodyMystery202002Text'),
    notes: t('bodyMystery202002Notes'),
    mystery: '202002',
    value: 0,
  },
};

const eyewear = {
  201503: {
    text: t('eyewearMystery201503Text'),
    notes: t('eyewearMystery201503Notes'),
    mystery: '201503',
    value: 0,
  },
  201506: {
    text: t('eyewearMystery201506Text'),
    notes: t('eyewearMystery201506Notes'),
    mystery: '201506',
    value: 0,
  },
  201507: {
    text: t('eyewearMystery201507Text'),
    notes: t('eyewearMystery201507Notes'),
    mystery: '201507',
    value: 0,
  },
  201701: {
    text: t('eyewearMystery201701Text'),
    notes: t('eyewearMystery201701Notes'),
    mystery: '201701',
    value: 0,
  },
  201902: {
    text: t('eyewearMystery201902Text'),
    notes: t('eyewearMystery201902Notes'),
    mystery: '201902',
    value: 0,
  },
  201907: {
    text: t('eyewearMystery201907Text'),
    notes: t('eyewearMystery201907Notes'),
    mystery: '201907',
    value: 0,
  },
  301404: {
    text: t('eyewearMystery301404Text'),
    notes: t('eyewearMystery301404Notes'),
    mystery: '301404',
    value: 0,
  },
  301405: {
    text: t('eyewearMystery301405Text'),
    notes: t('eyewearMystery301405Notes'),
    mystery: '301405',
    value: 0,
  },
  301703: {
    text: t('eyewearMystery301703Text'),
    notes: t('eyewearMystery301703Notes'),
    mystery: '301703',
    value: 0,
  },
};

const head = {
  201402: {
    text: t('headMystery201402Text'),
    notes: t('headMystery201402Notes'),
    mystery: '201402',
    value: 0,
  },
  201405: {
    text: t('headMystery201405Text'),
    notes: t('headMystery201405Notes'),
    mystery: '201405',
    value: 0,
  },
  201406: {
    text: t('headMystery201406Text'),
    notes: t('headMystery201406Notes'),
    mystery: '201406',
    value: 0,
  },
  201407: {
    text: t('headMystery201407Text'),
    notes: t('headMystery201407Notes'),
    mystery: '201407',
    value: 0,
  },
  201408: {
    text: t('headMystery201408Text'),
    notes: t('headMystery201408Notes'),
    mystery: '201408',
    value: 0,
  },
  201411: {
    text: t('headMystery201411Text'),
    notes: t('headMystery201411Notes'),
    mystery: '201411',
    value: 0,
  },
  201412: {
    text: t('headMystery201412Text'),
    notes: t('headMystery201412Notes'),
    mystery: '201412',
    value: 0,
  },
  201501: {
    text: t('headMystery201501Text'),
    notes: t('headMystery201501Notes'),
    mystery: '201501',
    value: 0,
  },
  201505: {
    text: t('headMystery201505Text'),
    notes: t('headMystery201505Notes'),
    mystery: '201505',
    value: 0,
  },
  201508: {
    text: t('headMystery201508Text'),
    notes: t('headMystery201508Notes'),
    mystery: '201508',
    value: 0,
  },
  201509: {
    text: t('headMystery201509Text'),
    notes: t('headMystery201509Notes'),
    mystery: '201509',
    value: 0,
  },
  201511: {
    text: t('headMystery201511Text'),
    notes: t('headMystery201511Notes'),
    mystery: '201511',
    value: 0,
  },
  201512: {
    text: t('headMystery201512Text'),
    notes: t('headMystery201512Notes'),
    mystery: '201512',
    value: 0,
  },
  201601: {
    text: t('headMystery201601Text'),
    notes: t('headMystery201601Notes'),
    mystery: '201601',
    value: 0,
  },
  201602: {
    text: t('headMystery201602Text'),
    notes: t('headMystery201602Notes'),
    mystery: '201602',
    value: 0,
  },
  201603: {
    text: t('headMystery201603Text'),
    notes: t('headMystery201603Notes'),
    mystery: '201603',
    value: 0,
  },
  201604: {
    text: t('headMystery201604Text'),
    notes: t('headMystery201604Notes'),
    mystery: '201604',
    value: 0,
  },
  201605: {
    text: t('headMystery201605Text'),
    notes: t('headMystery201605Notes'),
    mystery: '201605',
    value: 0,
  },
  201606: {
    text: t('headMystery201606Text'),
    notes: t('headMystery201606Notes'),
    mystery: '201606',
    value: 0,
  },
  201607: {
    text: t('headMystery201607Text'),
    notes: t('headMystery201607Notes'),
    mystery: '201607',
    value: 0,
  },
  201608: {
    text: t('headMystery201608Text'),
    notes: t('headMystery201608Notes'),
    mystery: '201608',
    value: 0,
  },
  201609: {
    text: t('headMystery201609Text'),
    notes: t('headMystery201609Notes'),
    mystery: '201609',
    value: 0,
  },
  201610: {
    text: t('headMystery201610Text'),
    notes: t('headMystery201610Notes'),
    mystery: '201610',
    value: 0,
  },
  201611: {
    text: t('headMystery201611Text'),
    notes: t('headMystery201611Notes'),
    mystery: '201611',
    value: 0,
  },
  201612: {
    text: t('headMystery201612Text'),
    notes: t('headMystery201612Notes'),
    mystery: '201612',
    value: 0,
  },
  201702: {
    text: t('headMystery201702Text'),
    notes: t('headMystery201702Notes'),
    mystery: '201702',
    value: 0,
  },
  201703: {
    text: t('headMystery201703Text'),
    notes: t('headMystery201703Notes'),
    mystery: '201703',
    value: 0,
  },
  201705: {
    text: t('headMystery201705Text'),
    notes: t('headMystery201705Notes'),
    mystery: '201705',
    value: 0,
  },
  201707: {
    text: t('headMystery201707Text'),
    notes: t('headMystery201707Notes'),
    mystery: '201707',
    value: 0,
  },
  201710: {
    text: t('headMystery201710Text'),
    notes: t('headMystery201710Notes'),
    mystery: '201710',
    value: 0,
  },
  201712: {
    text: t('headMystery201712Text'),
    notes: t('headMystery201712Notes'),
    mystery: '201712',
    value: 0,
  },
  201802: {
    text: t('headMystery201802Text'),
    notes: t('headMystery201802Notes'),
    mystery: '201802',
    value: 0,
  },
  201803: {
    text: t('headMystery201803Text'),
    notes: t('headMystery201803Notes'),
    mystery: '201803',
    value: 0,
  },
  201805: {
    text: t('headMystery201805Text'),
    notes: t('headMystery201805Notes'),
    mystery: '201805',
    value: 0,
  },
  201806: {
    text: t('headMystery201806Text'),
    notes: t('headMystery201806Notes'),
    mystery: '201806',
    value: 0,
  },
  201807: {
    text: t('headMystery201807Text'),
    notes: t('headMystery201807Notes'),
    mystery: '201807',
    value: 0,
  },
  201808: {
    text: t('headMystery201808Text'),
    notes: t('headMystery201808Notes'),
    mystery: '201808',
    value: 0,
  },
  201809: {
    text: t('headMystery201809Text'),
    notes: t('headMystery201809Notes'),
    mystery: '201809',
    value: 0,
  },
  201810: {
    text: t('headMystery201810Text'),
    notes: t('headMystery201810Notes'),
    mystery: '201810',
    value: 0,
  },
  201811: {
    text: t('headMystery201811Text'),
    notes: t('headMystery201811Notes'),
    mystery: '201811',
    value: 0,
  },
  201901: {
    text: t('headMystery201901Text'),
    notes: t('headMystery201901Notes'),
    mystery: '201901',
    value: 0,
  },
  201903: {
    text: t('headMystery201903Text'),
    notes: t('headMystery201903Notes'),
    mystery: '201903',
    value: 0,
  },
  201904: {
    text: t('headMystery201904Text'),
    notes: t('headMystery201904Notes'),
    mystery: '201904',
    value: 0,
  },
  201907: {
    text: t('headMystery201907Text'),
    notes: t('headMystery201907Notes'),
    mystery: '201907',
    value: 0,
  },
  201909: {
    text: t('headMystery201909Text'),
    notes: t('headMystery201909Notes'),
    mystery: '201909',
    value: 0,
  },
  201910: {
    text: t('headMystery201910Text'),
    notes: t('headMystery201910Notes'),
    mystery: '201910',
    value: 0,
  },
  201911: {
    text: t('headMystery201911Text'),
    notes: t('headMystery201911Notes'),
    mystery: '201911',
    value: 0,
  },
  201912: {
    text: t('headMystery201912Text'),
    notes: t('headMystery201912Notes'),
    mystery: '201912',
    value: 0,
  },
  202001: {
    text: t('headMystery202001Text'),
    notes: t('headMystery202001Notes'),
    mystery: '202001',
    value: 0,
  },
  301404: {
    text: t('headMystery301404Text'),
    notes: t('headMystery301404Notes'),
    mystery: '301404',
    value: 0,
  },
  301405: {
    text: t('headMystery301405Text'),
    notes: t('headMystery301405Notes'),
    mystery: '301405',
    value: 0,
  },
  301703: {
    text: t('headMystery301703Text'),
    notes: t('headMystery301703Notes'),
    mystery: '301703',
    value: 0,
  },
  301704: {
    text: t('headMystery301704Text'),
    notes: t('headMystery301704Notes'),
    mystery: '301704',
    value: 0,
  },
};

const headAccessory = {
  201403: {
    text: t('headAccessoryMystery201403Text'),
    notes: t('headAccessoryMystery201403Notes'),
    mystery: '201403',
    value: 0,
  },
  201404: {
    text: t('headAccessoryMystery201404Text'),
    notes: t('headAccessoryMystery201404Notes'),
    mystery: '201404',
    value: 0,
  },
  201409: {
    text: t('headAccessoryMystery201409Text'),
    notes: t('headAccessoryMystery201409Notes'),
    mystery: '201409',
    value: 0,
  },
  201502: {
    text: t('headAccessoryMystery201502Text'),
    notes: t('headAccessoryMystery201502Notes'),
    mystery: '201502',
    value: 0,
  },
  201510: {
    text: t('headAccessoryMystery201510Text'),
    notes: t('headAccessoryMystery201510Notes'),
    mystery: '201510',
    value: 0,
  },
  201801: {
    text: t('headAccessoryMystery201801Text'),
    notes: t('headAccessoryMystery201801Notes'),
    mystery: '201801',
    value: 0,
  },
  201804: {
    text: t('headAccessoryMystery201804Text'),
    notes: t('headAccessoryMystery201804Notes'),
    mystery: '201804',
    value: 0,
  },
  201812: {
    text: t('headAccessoryMystery201812Text'),
    notes: t('headAccessoryMystery201812Notes'),
    mystery: '201812',
    value: 0,
  },
  201905: {
    text: t('headAccessoryMystery201905Text'),
    notes: t('headAccessoryMystery201905Notes'),
    mystery: '201905',
    value: 0,
  },
  201906: {
    text: t('headAccessoryMystery201906Text'),
    notes: t('headAccessoryMystery201906Notes'),
    mystery: '201906',
    value: 0,
  },
  201908: {
    text: t('headAccessoryMystery201908Text'),
    notes: t('headAccessoryMystery201908Notes'),
    mystery: '201908',
    value: 0,
  },
  301405: {
    text: t('headAccessoryMystery301405Text'),
    notes: t('headAccessoryMystery301405Notes'),
    mystery: '301405',
    value: 0,
  },
};

const shield = {
  201601: {
    text: t('shieldMystery201601Text'),
    notes: t('shieldMystery201601Notes'),
    mystery: '201601',
    value: 0,
  },
  201701: {
    text: t('shieldMystery201701Text'),
    notes: t('shieldMystery201701Notes'),
    mystery: '201701',
    value: 0,
  },
  201708: {
    text: t('shieldMystery201708Text'),
    notes: t('shieldMystery201708Notes'),
    mystery: '201708',
    value: 0,
  },
  201709: {
    text: t('shieldMystery201709Text'),
    notes: t('shieldMystery201709Notes'),
    mystery: '201709',
    value: 0,
  },
  201802: {
    text: t('shieldMystery201802Text'),
    notes: t('shieldMystery201802Notes'),
    mystery: '201802',
    value: 0,
  },
  201902: {
    text: t('shieldMystery201902Text'),
    notes: t('shieldMystery201902Notes'),
    mystery: '201902',
    value: 0,
  },
  301405: {
    text: t('shieldMystery301405Text'),
    notes: t('shieldMystery301405Notes'),
    mystery: '301405',
    value: 0,
  },
  301704: {
    text: t('shieldMystery301704Text'),
    notes: t('shieldMystery301704Notes'),
    mystery: '301704',
    value: 0,
  },
};

const weapon = {
  201411: {
    text: t('weaponMystery201411Text'),
    notes: t('weaponMystery201411Notes'),
    mystery: '201411',
    value: 0,
  },
  201502: {
    text: t('weaponMystery201502Text'),
    notes: t('weaponMystery201502Notes'),
    mystery: '201502',
    value: 0,
  },
  201505: {
    text: t('weaponMystery201505Text'),
    notes: t('weaponMystery201505Notes'),
    mystery: '201505',
    value: 0,
  },
  201611: {
    text: t('weaponMystery201611Text'),
    notes: t('weaponMystery201611Notes'),
    mystery: '201611',
    value: 0,
  },
  201708: {
    text: t('weaponMystery201708Text'),
    notes: t('weaponMystery201708Notes'),
    mystery: '201708',
    value: 0,
  },
  201811: {
    text: t('weaponMystery201811Text'),
    notes: t('weaponMystery201811Notes'),
    mystery: '201811',
    value: 0,
  },
  201911: {
    text: t('weaponMystery201911Text'),
    notes: t('weaponMystery201911Notes'),
    mystery: '201911',
    value: 0,
  },
  202002: {
    text: t('weaponMystery202002Text'),
    notes: t('weaponMystery202002Notes'),
    mystery: '202002',
    value: 0,
  },
  301404: {
    text: t('weaponMystery301404Text'),
    notes: t('weaponMystery301404Notes'),
    mystery: '301404',
    value: 0,
  },
};

export {
  armor,
  back,
  body,
  eyewear,
  head,
  headAccessory,
  shield,
  weapon,
};
